import React, { useState, createContext } from 'react';
import { Header } from '../../pages/Dashboard/Header';
import { Footer } from '../../pages/Dashboard/Footer';
import ScrollButton from '../../utils/ScrollButton/ScrollButton';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Dashboard.css';

import { useDateUtils } from '../../utils/Hooks/useDateUtils';

export const CountContext = createContext();
export const ParentContext = createContext();
export const CompanyContext = createContext();
export const EmployeeContext = createContext();
export const StateContext = createContext();
export const ActivityContext = createContext();
export const CarouselContext = createContext();

export const ActivityProvider = ({ children }) => {
  const { formatDate, next } = useDateUtils();
  const [searchOptions, setSearchOptions] = useState({ mode: 0, value: 0, data: "" });
  const [resetActivityPage, setResetActivityPage] = useState(false);
  const [activities, setActivities] = useState([]);
  const [resetFilters, setResetFilters] = useState(false);
  const [activityCount, setActivityCount] = useState(0);
  const [activityFilters, setActivityFilters] = useState({
    parentId: 0,
    companyId: 0,
    activityFor: 0,
    contactId: 0,
    contactName: "",
    salesRepId: 0,
    activityType: 0,
    recurrence: -1,
    status: 0,
    dateType: 0,
    dateRange: 0,
    dateRangeStart: formatDate(new Date('01/01/1980')),
    dateRangeEnd: next(7),
    filterTotal: 0,
    applyFilter: false,
    checkNotes: false
  });
  const resetState = () => {
    setSearchOptions({ mode: 0, value: 0, data: "" });
    setResetFilters(false);
  };
  const resetActivityCount = () => {
    setActivityCount(0);
  };

  const value = {
    activityFilters,
    setActivityFilters,
    searchOptions,
    setSearchOptions,
    resetActivityPage,
    setResetActivityPage,
    resetFilters,
    setResetFilters,
    activities,
    setActivities,
    resetState,
    activityCount,
    setActivityCount,
    resetActivityCount
  };

  return (
    <ActivityContext.Provider value={value}>
      {children}
    </ActivityContext.Provider>
  );
};

export const CarouselProvider = ({children}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDisplayed, setTotalDisplayed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const value = {
    currentPage,
    setCurrentPage,
    totalRecords,
    setTotalRecords,
    totalDisplayed,
    setTotalDisplayed,
    totalPages,
    setTotalPages,
    loading,
    setLoading
  }
  return (
    <CarouselContext.Provider value={value}>
      {children}
    </CarouselContext.Provider>
  );
};

// Create Count Provider
const CountProvider = ({ children }) => {
  const [companyCount, setCompanyCount] = useState(0);
  const [contactCount, setContactCount] = useState(0);
  
  const [orderCount, setOrderCount] = useState(0);
  const resetCount = () => {
    setCompanyCount(0);
    setContactCount(0);
    setOrderCount(0);
  };
  return (
    <CountContext.Provider value={{ companyCount, setCompanyCount, contactCount, setContactCount, orderCount, setOrderCount, resetCount }}>
      {children}
    </CountContext.Provider>
  );
};

// Create Parent Companies Provider
const ParentProvider = ({ children }) => {
  const [allParents, setAllParents] = useState([]);
  const [selectedParentID, setSelectedParentID] = useState(0);
  const resetParent = () => {
    setSelectedParentID(0);
  };
  return (
    <ParentContext.Provider value={{ allParents, setAllParents, selectedParentID, setSelectedParentID, resetParent }}>
      {children}
    </ParentContext.Provider>
  );
};
// Create Companies Provider
const CompanyProvider = ({ children }) => {
  const [allCompanies, setAllCompanies] = useState([]); //this is the list of filtered companies
  const [selectedCompanyID, setSelectedCompanyID] = useState(0);
  const [selectedCompanyParentID, setSelectedCompanyParentID] = useState(0);
  const resetCompany = () => {
    setSelectedCompanyID(0);
    setSelectedCompanyParentID(0);
  };
  return (
    <CompanyContext.Provider value={{
      allCompanies, setAllCompanies,
      selectedCompanyID, setSelectedCompanyID,
      selectedCompanyParentID, setSelectedCompanyParentID,
      resetCompany
    }}>
      {children}
    </CompanyContext.Provider>
  );
};

// Create Employees Provider
const EmployeeProvider = ({ children }) => {
  const [allEmployees, setAllEmployees] = useState([]);
  return (
    <EmployeeContext.Provider value={{ allEmployees, setAllEmployees }}>
      {children}
    </EmployeeContext.Provider>
  );
};

// Create State Provider
const StateProvider = ({ children }) => {
  const [allStates, setAllStates] = useState([]);
  return (
    <StateContext.Provider value={{
      allStates, setAllStates
    }}>
      {children}
    </StateContext.Provider>
  );
};

export const LayoutDashboard = ({ version, children }) => (
  <>
    <div className='body-grid'>
      <CountProvider>
        <ParentProvider>
          <CompanyProvider>
            <EmployeeProvider>
              <ActivityProvider>
                <StateProvider>
                  <CarouselProvider>
                    <Header />
                    <main className='site-content'>
                      {children}
                      <ScrollButton />
                    </main>
                    <ToastContainer className='mb-5' />
                    <Footer version={version} />
                  </CarouselProvider>
                </StateProvider>
              </ActivityProvider>
            </EmployeeProvider>
          </CompanyProvider>
        </ParentProvider>
      </CountProvider>
    </div>
  </>
);